import { QueryClient } from "@tanstack/react-query";

/**
 * Shared TanStack Query client. Caches server responses only — it never
 * derives or stores a computed business fact of its own; every cached
 * value is exactly what a backend endpoint returned.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
